import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import MediaFilesLibrary from '../../../../../../../../ReusableFormFields/MediaFilesLibrary'

import { selectedGoogleAdAccountSelector } from '../../../../../../../../../modules/selectors/adAccounts'
import {
  assetsErrorSelector,
  assetsIsLoadingSelector,
  assetsNextPageTokenSelector,
  assetsWasLoadedSelector,
  imageAssetsSelector
} from '../../../../../../../../../modules/selectors/assets'
import { clearAssets, getAssets } from '../../../../../../../../../modules/actions/assets'

const GoogleImageFilesLibrary = ({ adAccountId, width, height, ...props }) => {
  const dispatch = useDispatch()

  const nextPageToken = useSelector(assetsNextPageTokenSelector)

  const { id: selectedAdAccountId } = useSelector(selectedGoogleAdAccountSelector)

  // when ad account is manually passed from outside, use it instead of selected
  const providerAdAccountId = adAccountId || selectedAdAccountId

  const loadInitialMediaHandler = useCallback(() => {
    dispatch(
      getAssets({
        account: providerAdAccountId,
        asset_type: 4,
        page_size: 12,
        height,
        width
      })
    )
  }, [dispatch, providerAdAccountId, height, width])

  const loadMoreHandler = useCallback(() => {
    dispatch(
      getAssets({
        account: providerAdAccountId,
        asset_type: 4,
        page_size: 12,
        page_token: nextPageToken,
        height,
        width
      })
    )
  }, [dispatch, providerAdAccountId, nextPageToken, height, width])

  const clearAssetsHandler = useCallback(() => {
    dispatch(clearAssets())
  }, [dispatch])

  return (
    <MediaFilesLibrary
      type="image"
      mediaThumbnailFieldName="url"
      mediaFilesSelector={imageAssetsSelector}
      mediaFilesIsLoadingSelector={assetsIsLoadingSelector}
      mediaFilesErrorSelector={assetsErrorSelector}
      mediaFilesWasLoadedSelector={assetsWasLoadedSelector}
      mediaFilesNextSelector={assetsNextPageTokenSelector}
      loadInitialMediaHandler={loadInitialMediaHandler}
      loadMoreHandler={loadMoreHandler}
      clearMediaHandler={clearAssetsHandler}
      {...props}
    />
  )
}

export default GoogleImageFilesLibrary
